import styled from 'styled-components';
import { AppBar } from '@equinor/opt-ui-core';
// Eds topBar
export const TopBar = styled(AppBar) `
  display: flex;
  > div {
    flex: 1;
  }
`;
// TopBar title
export const Title = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 0 0;
  font-size: 28px;
  font-weight: 500;
  line-height: 28px;
`;
// Right section on the topBar
export const Icons = styled.div `
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  > * {
    margin-left: 20px;
  }
`;
export const UserContainer = styled.div `
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;
  justify-content: space-between;
`;
